module.exports = __webpack_public_path__ + "e31d54e9b4cad33ba8fda086fac94a29.svg";